<template>
  <div />
</template>

<script>
export default {
  name: 'ActivityDetailRedirect',
  created() {
    this.$router.replace('/activity');
  },
};
</script>
